export default __webpack_public_path__ + "static/media/massup_xl2.0db710c2.png";